import classNames from 'classnames';
import { SquaredThumbnail } from '@appcomponents/atoms/squared-thumbnail';
import { CompanyService } from '@src/@data/types/services';
import { ColorCircle } from '@appcomponents/atoms/ColorCircle';
import { ScheduleColors } from '@src/@data/types/scheduleColors';
import React from 'react';

import './selectable-service-info.scss';

interface ServiceInfoProps
  extends Pick<CompanyService, 'thumbnail' | 'title' | 'scheduleColor'> {
  className?: string;
  subtitle?: string;
  rightComponent?: React.ReactNode;
  onClick?: () => void;
}

export const SelectableServiceInfo: React.FC<ServiceInfoProps> = ({
  thumbnail,
  title,
  scheduleColor,
  className,
  subtitle,
  rightComponent,
  onClick,
}) => {
  return (
    <div className={classNames(className, 'service-info')} onClick={onClick}>
      <SquaredThumbnail thumbnail={thumbnail} className="mr-75">
        <div className="service-badge">
          <ColorCircle
            {...ScheduleColors[scheduleColor]}
            className="service-badge-inner"
          />
        </div>
      </SquaredThumbnail>
      <div className="d-flex flex-column flex-grow-1 align-self-center">
        <span>{title}</span>
        {!!subtitle && <small className="text-secondary">{subtitle}</small>}
      </div>
      {rightComponent}
    </div>
  );
};
